import { GroupTranslation } from '@d-id/types';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { TranslationGroupProofreadFormData } from '../../state/types';
import { getFlag } from '../../utils/ui';

const ListItem = styled.li`
    display: flex;
    align-items: center;
    min-height: 3rem;
`;

const Img = styled.img`
    width: 20px;
    height: 14px;
    margin-right: 1.2rem;
`;

const LanguageText = styled(Typography)`
    font-weight: 500;
    text-transform: capitalize;
    user-select: none;
    margin-inline-end: 0.8rem;
`;

const EditedBadge = styled(Typography)`
    color: ${({ theme }) => theme.colors.links.main};
    background-color: ${({ theme }) => theme.colors.links.light};
    font-size: 1.2rem;
    line-height: 1.454rem;
    padding: 0.2rem 0.4rem;
    border-radius: 0.4rem;
`;

interface IProps {
    translation: GroupTranslation;
}

function TranslationListItem({ translation }: IProps) {
    const { formState, getFieldState } = useFormContext<TranslationGroupProofreadFormData>();
    const { isDirty } = getFieldState(`captionsByTranslationId.${translation.id}.sentences`, formState);

    return (
        <ListItem>
            {getFlag(Img, translation.locale)}
            <LanguageText variant="body2">{translation.language}</LanguageText>
            {isDirty && <EditedBadge variant="body2">Edited</EditedBadge>}
        </ListItem>
    );
}

export default TranslationListItem;
